import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-pageCW-tabs margin-bottom" }
const _hoisted_2 = { class: "m-pageCW-tabs-item-total" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageCW-tabs-item-name" }, " Строительные работы ", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "m-pageCW-tabs-item-notification d-none"
}
const _hoisted_5 = { class: "m-pageCW-tabs-item-total" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageCW-tabs-item-name" }, " Коммунальные отключения ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["m-pageCW-tabs-item", {'active': _ctx.isShowCW}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-tab', 'construction-work')))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.workTotalCount), 1 /* TEXT */),
      _hoisted_3,
      (_ctx.works.unReadCount && _ctx.works.unReadCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.works.unReadCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["m-pageCW-tabs-item", {'active': _ctx.isShowIncident}]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-tab', 'incident')))
    }, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.incidentTotalCount), 1 /* TEXT */),
      _hoisted_6
    ], 2 /* CLASS */)
  ]))
}